// Copyright (c) 2017 Deere & Company

import ClosingAccountChanges from '../state/closing-account';
import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const updateClosingAccountChanges = (state, action) =>
ClosingAccountChanges.update(state, {
    $set: action.data
});

const updateClosingAccountwithOverride = (state, action) =>
ClosingAccountChanges.update(state, {
    [action.overrideAccount.account]: {
        $set: action.overrideAccount
    }
});

export default (state = getWipDefaultState().closingAccountChanges, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_CLOSING_ACCOUNT]: updateClosingAccountChanges,
        [actions.UPDATE_OVERRIDE_CLOSE_ACCOUNT]: updateClosingAccountwithOverride
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/closing-account.js